// import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import {  VueAxios } from './axios'
import { Toast } from 'vant'
import { getUrlKey, getCookie,getCookieuUne } from '@/utils/util'
import layer from "layui-layer";
import Vue from 'vue'
import { MessageBox,Message } from 'element-ui'
// 解析post方式的字符串
import qs from 'qs'
// 引入路由router
import router from '@/router'
// import { ACCESS_TOKEN } from '@/store/mutation-types'
let inApp = false
// 创建 axios 实例
//console.log('环境', process.env.NODE_ENV, process.env.VUE_APP_requestUrl)
// 是否展示错误弹窗
let noToastFlag = []

//const urlHead = process.env.NODE_ENV.includes('dev') ? '/api' : process.env.VUE_APP_requestUrl // api base_url
//const urlHead = process.env.VUE_APP_requestUrl     ///接口地址gy
//const urlHead="http://218.57.145.134:8181/jeecg-boot/"
const urlHead="https://www.zgjzcy.org.cn/"
//const urlHead="/"
//http://inspur.xinh.cebest.com/jeecg-boot/    测试接口地址
//http://218.57.145.134:8181/jeecg-boot/       正式接口地址

const service = axios.create({
  baseURL: urlHead,
  // headers: {'X-Access-Token': '','access-control-allow-origin': urlHead}, 
  timeout: 10000 // 请求超时时间
})

const err = (error) => {
  if (error.response) {
    let data = error.response.data
    const token = window.localStorage.getItem("token");
    // const token = Vue.ls.get(ACCESS_TOKEN)
    //console.log("------异常响应------",token)
    //console.log("------异常响应------",error.response.status)
    switch (error.response.status) {
      case 403:
        Message({
          message: '拒绝访问',
          type: 'error'
        })
        break
      case 500:
        //console.log("------error.response------",error.response)
        // update-begin- --- author:liusq ------ date:20200910 ---- for:处理Blob情况----
        let type=error.response.request.responseType;
        if(type === 'blob'){
          blobToJson(data);
          break;
        }
        // update-end- --- author:liusq ------ date:20200910 ---- for:处理Blob情况----
        if(data.message.includes("Token失效")){
            MessageBox.confirm(
              '很抱歉，未登录或登录已过期，请先登录~',
              '请先登录',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }
            ).then(() => {
              // window.sessionStorage.removeItem('token')
              // window.sessionStorage.removeItem('username')
              // window.localStorage.removeItem('token');
              // window.localStorage.removeItem('username');
              // window.location.reload()

              
              axios.get(urlHead + 'render/unify').then(function (res) {
                if (res.data.success) {
                  window.open(res.data.result)
                } else {
                  Message({
                    message: res.data.message,
                    type: 'warning'
                  })
                }
              })
            }).catch(action => {
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('username')
              window.localStorage.removeItem('token');
              window.localStorage.removeItem('username');

              let url=window.location.protocol+'//'+window.location.hostname
              window.location.href='https://www.ssoieop.com.cn/esc-sso/logout?service='+url
              //window.location.reload()
            });
          // update-end- --- author:scott ------ date:20190225 ---- for:Token失效采用弹框模式，不直接跳转----
        }
        break
      case 404:
        Message({
          message: '抱歉，资源未找到!',
          type: 'warning'
        })
        break
      case 504:
        Message({
          message: '网络超时',
          type: 'warning'
        })
        break
      case 401:

        // Vue.prototype.$Jnotification.error({ message: '系统提示', description:'未授权，请重新登录',duration: 4})
        // if (token) {
        //   store.dispatch('Logout').then(() => {
        //     setTimeout(() => {
        //       window.location.reload()
        //     }, 1500)
        //   })
        // }
        break
      default:
        Message({
          message: '网络超时',
          type: 'warning'
        })
        break
    }
  } else if (error.message) {
    if (error.message.includes('timeout')) {
      Message({
        message: '网络超时',
        type: 'warning'
      })
    } else {
      Message({
        message: error.message,
        type: 'error'
      })
    }
  }

  return Promise.reject(error)
};


// 生成通用必传参数
const createParameters = function () {
  inApp = (getUrlKey('appType') === 'android' || getUrlKey('appType') === 'ios' || getCookie('publicParams'))
  let params = {
    k:store.state.shortToken,  // 访问的会话token
  }
  if(inApp){
    params = JSON.parse(getCookie('publicParams'))
    for(let key in params){
      params[key] = decodeURI(params[key])
    }
  }
  return params
}
// 封装拼接通用必传参数
const addParameters = function (config) {
  //const parameters = createParameters()
  const parameters = ''
  // 确认订单 需要json
  if(config.headers['Content-Type'] === 'application/json'){
    config.data = {
      ...parameters,
      ...config.data
    }
  }else if (config.method === 'get') {
    config.params = {
      ...parameters,
      ...config.params
    }
    
  } else if (config.method === 'post') {
    let data = qs.parse(config.data)
    config.data = qs.stringify({
      ...parameters,
      ...data
    })
  }
  return config
}

// 请求拦截器
service.interceptors.request.use(config => {
  //设置7天登录
  (function(){
    var sessionToken = window.sessionStorage.getItem("token");
    var cookToken = getCookieuUne("token");
    if(sessionToken){
      store.commit('memoryData',{'shortToken':sessionToken})
      return
    }else if(cookToken&&cookToken!='null'){
      store.commit('memoryData',{'shortToken':cookToken})
      return
    }else{
      store.commit('memoryData',{'shortToken':'0'})
    }
  })()
  // 在此添加参数，这里只会当接口被调用时才会真正触发
  config = addParameters(config)
  return config
}, err)

// 响应拦截器
service.interceptors.response.use((resConfig) => {
  // 拦截长token, 用户未登录或者登录失效
  // console.log(resConfig)
  if (!resConfig.data.success && resConfig.data.code==502 ) {
    router.push({
      name: 'login',
      query: { redirect: router.currentRoute.fullPath }
    })
    
    if (resConfig.data.msg && resConfig.data.code != '1060000') {
      Toast(resConfig.data.msg)
    }

    return resConfig.data
  }
  // 拦截短token过期--本地短token可能存在,但是后端返回过期。重新获取短token,判断长token是否存在，如果存在并且过期，跳转登录页。如果不存在，说明不必登录,只需短token重新设置即可。
  else if (resConfig.data.code === 1060001) {
    // 没有token的话请求接口获取，注意这里的路径，由于是devserver的proxy代理
    return axios.post(urlHead + '/login', qs.stringify(createParameters())).then(function (res) {
      // 请求成功，存储token
      if (res.success) {
        // 短token过期的话，在请求新token之后，要重新请求接口
        window.sessionStorage.setItem("token",res.result.token);
        store.commit('setShortToken', res.result.token)
        // 如果本地存储长token存在，进行静默登录，过期的话--->跳转登录页。
        // return new Promise(function (resolve) {
        //   resolve(validateLongToken(resConfig))
        // })
      } else {
        Toast('网络错误,请稍后再试~')
        return Promise.resolve('网络错误,请稍后再试~')
      }
    })
  }
  else if (resConfig.data.code === 200) {
    return resConfig.data
  } else {
    if (resConfig.data.msg && !noToastFlag.includes(resConfig.config.url)) {
      // Toast(`${resConfig.config.url.split('/').pop()}|${resConfig.data.msg}`)
      Toast(`${resConfig.data.msg}`)
    }
    return Promise.resolve(resConfig.data)
  }
}, err)

let noGetAdd = true
function api ({ method, data, contentType = 'urlencoded', noToast = false, payHeader = false }, url) {
  if(noToast){
    noToastFlag.push(url)
  }

  //console.log("store.state.shortToken",store.state.shortToken)
  // 1.判断本地是否有token
  // if (store.state.shortToken === '0' && noGetAdd) {
  //   noGetAdd = false
  //   return new Promise( (resolve, reject) => {
  //   })
  // } else {
    // 2.有token的话
    if (method && method.toLowerCase() === 'get') {
      var contentTypeObj = {
        urlencoded: 'application/x-www-form-urlencoded',    ///application/x-www-form-urlencoded   接口500修改gy
        json: 'application/json',
        formData: 'multipart/form-data'
      }

      const config = {
        headers: {
          'Content-Type': contentTypeObj[contentType]
        }
      }

      if(payHeader){
        config.headers['X-Access-Token'] = window.localStorage.getItem("token");
      }

      if(contentType === 'json'){
        data = qs.parse(data)
      }

      return service.get(url, config)
      // return service.get(url, {params: data},config)
      //return service.get(url, data,config)
    } else if(method && method.toLowerCase() === 'post') {
      var contentTypeObj = {
        urlencoded: 'application/x-www-form-urlencoded',    ///application/x-www-form-urlencoded   接口500修改gy
        json: 'application/json',
        formData: 'multipart/form-data'
      }

      const config = {
        headers: {
          'Content-Type': contentTypeObj[contentType]
        }
      }
      if(payHeader){
        config.headers['X-Access-Token'] = window.localStorage.getItem("token");
      }

      // console.log(contentType,'contentType')

      if(contentType === 'json'){
        data = qs.parse(data)
      }
      return service.post(url, data, config)

    }else if(method && method.toLowerCase() === 'put') {
      var contentTypeObj = {
        urlencoded: 'application/json',    ///application/x-www-form-urlencoded   接口500修改gy
        json: 'application/json',
        formData: 'multipart/form-data'
      }

      const config = {
        headers: {
          'Content-Type': contentTypeObj[contentType]
        }
      }
      if(payHeader){
        config.headers['X-Access-Token'] = window.localStorage.getItem("token");
      }
      
      if(contentType === 'json'){
        data = qs.parse(data)
      }
      
      return service.put(url, data, config)
    }else if (method && method.toLowerCase() === 'delete') {

      var contentTypeObj = {
        urlencoded: 'application/json',    ///application/x-www-form-urlencoded   接口500修改gy
        json: 'application/json',
        formData: 'multipart/form-data'
      }

      const config = {
        headers: {
          'Content-Type': contentTypeObj[contentType]
        }
      }

      if(payHeader){
        config.headers['X-Access-Token'] = window.localStorage.getItem("token");
      }

      if(contentType === 'json'){
        data = qs.parse(data)
      }

      return service.delete(url, config)
    }
  //}
}

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, service)
  }
}

/**
 * Blob解析
 * @param data
 */
function blobToJson(data) {
  let fileReader = new FileReader();
  let token = Vue.ls.get(ACCESS_TOKEN);
  fileReader.onload = function() {
    try {
      let jsonData = JSON.parse(this.result);  // 说明是普通对象数据，后台转换失败
      //console.log("jsonData",jsonData)
      if (jsonData.status === 500) {
        console.log("token----------》",token)
        if(token && jsonData.message.includes("Token失效")){
          Modal.error({
            title: '登录已过期',
            content: '很抱歉，登录已过期，请重新登录',
            okText: '重新登录',
            mask: false,
            onOk: () => {
              store.dispatch('Logout').then(() => {
                Vue.ls.remove(ACCESS_TOKEN)

                window.sessionStorage.removeItem('token')
                window.sessionStorage.removeItem('username')
                window.localStorage.removeItem('token');
                window.localStorage.removeItem('username');
                window.location.reload()
              })
            }
          })
        }
      }
    } catch (err) {
      // 解析成对象失败，说明是正常的文件流
      console.log("blob解析fileReader返回err",err)
    }
  };
  fileReader.readAsText(data)
}

export {
  installer as VueAxios,
  api as axios,
  urlHead
}



// WEBPACK FOOTER //
// ./src/utils/http.js